module.exports = __webpack_public_path__ + "static/media/muskurahat.17df9a10.png";